import { BOOKING_MAX_MONTHS } from './schedule.constants';
import { mondayOf, startOfDay } from './schedule.utils';

export function bookableMinDay(): Date {
  const d = startOfDay(new Date());
  d.setDate(d.getDate() + 1);
  return d;
}

export function bookableMaxDay(): Date {
  const d = startOfDay(new Date());
  d.setMonth(d.getMonth() + BOOKING_MAX_MONTHS);
  return d;
}

export function isBookableDay(date: Date): boolean {
  const d = startOfDay(date);
  return d.getTime() >= bookableMinDay().getTime()
      && d.getTime() <= bookableMaxDay().getTime();
}

export function isMiniCalDayDisabled(date: Date): boolean {
  return !isBookableDay(date);
}

export function clampWeekStart(monday: Date): Date {
  const min = mondayOf(bookableMinDay());
  const max = mondayOf(bookableMaxDay());
  const t   = monday.getTime();
  if (t < min.getTime()) return new Date(min);
  if (t > max.getTime()) return new Date(max);
  return new Date(monday);
}

export function initialBookableWeekStart(): Date {
  return clampWeekStart(mondayOf(new Date()));
}
